import { localeFormat } from "utils/dates"
import { SHORT_DATE_FORMAT_ENGLISH, SHORT_DATE_FORMAT_HEBREW } from "./dateConsts"

export const getDateLocaleFormat = (date: Date, format?: string, i18n?: any) => {
    const defaultFormat = i18n.language === "he" ? SHORT_DATE_FORMAT_HEBREW : SHORT_DATE_FORMAT_ENGLISH
    return localeFormat(date, format ?? defaultFormat, i18n)
}
